module.exports = __webpack_public_path__ + "063152138f797b7b61a1f635807b484d.png";